/* eslint-disabled */
import TypeAvenant from "./TypeAvenant";
import FeatureExtend from "@/entity/extends/FeatureExtend";
import { hydrateCollection } from "@/Utils/EntityHelper";

export default class Feature extends FeatureExtend {


public id!: number;
public code = '';
public label = '';
public typeAvenants: Array<TypeAvenant> = [];

  constructor (object?: any) {
      super(object)
      if(object){
        this.id= object.id;
       this.code= object.code;
       this.label= object.label;
            hydrateCollection(object.typeAvenants, TypeAvenant, this.typeAvenants);
      }
      this.postConstruct()
  }

}
